import {
  Sun,
  Moon,
  Cloud,
  CloudSun,
  CloudMoon,
  Cloudy,
  CloudRain,
  CloudDrizzle,
  CloudLightning,
  CloudSnow,
  CloudFog,
} from "lucide-react";

const MAP = {
  "01d": Sun,
  "01n": Moon,
  "02d": CloudSun,
  "02n": CloudMoon,
  "03d": Cloud,
  "03n": Cloud,
  "04d": Cloudy,
  "04n": Cloudy,
  "09d": CloudDrizzle,
  "09n": CloudDrizzle,
  "10d": CloudRain,
  "10n": CloudRain,
  "11d": CloudLightning,
  "11n": CloudLightning,
  "13d": CloudSnow,
  "13n": CloudSnow,
  "50d": CloudFog,
  "50n": CloudFog,
};

export const WeatherIcon = ({ icon, className = "", spin = false, style }) => {
  const Icon = MAP[icon] || Cloud;
  const isSun = icon === "01d";
  return (
    <Icon
      className={`${className} ${spin && isSun ? "spin-slow" : ""}`}
      strokeWidth={1.6}
      style={style}
    />
  );
};
